




































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, TextArea } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, numeric, ipAddress, maxLength } from 'vuelidate/lib/validators'

// models
import { DeviceForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { DeviceService } from '@/services/config'

const initItem: DeviceForm = {
  name: '',
  ip: '',
  port: '4370',
  observation: '',
  is_active: true,
  amount_max_users: 1000,
  amount_max_attendance: 10000
}

@Component({
    name: 'FormCreateEditDevice',
    components: {
        Input,
        Radio,
        TextArea
    },
    mixins: [validationMixin]
})
export default class FormCreateEditDevice extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) device!: DeviceForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: DeviceForm = {
        name: '',
        ip: '',
        port: '4370',
        observation: '',
        is_active: true,
        amount_max_users: 1000,
        amount_max_attendance: 10000
    }

    created () {
        if (this.idEdit) {
            this.form = this.device
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                ip: { required, ipAddress },
                port: { required, minLength: minLength(2), maxLength: maxLength(4), numeric },
                amount_max_users: { required, numeric },
                amount_max_attendance: { required, numeric },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            this.form.amount_max_users = parseInt(String(this.form.amount_max_users))
            this.form.amount_max_attendance = parseInt(String(this.form.amount_max_attendance))
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await DeviceService.update(this.idEdit, this.form)
                } else {
                    await DeviceService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = initItem
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
